var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreadslarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.07 11.12-.32-.14c-.18-3.41-2.05-5.37-5.18-5.39h-.04c-1.88 0-3.43.8-4.4 2.26l1.73 1.18a3.05 3.05 0 0 1 2.7-1.32c1.03 0 1.8.3 2.31.9.37.42.61 1 .73 1.75-.91-.16-1.9-.2-2.96-.14-2.97.17-4.89 1.9-4.76 4.32A3.72 3.72 0 0 0 9.6 17.5a5.3 5.3 0 0 0 3.2.8 4.72 4.72 0 0 0 3.62-1.76 6.54 6.54 0 0 0 1.24-3.24c.74.44 1.3 1.03 1.6 1.74.51 1.2.54 3.19-1.07 4.8-1.42 1.41-3.12 2.02-5.69 2.04-2.85-.02-5-.93-6.4-2.72-1.32-1.66-2-4.07-2.02-7.16.02-3.09.7-5.5 2.01-7.16 1.4-1.79 3.56-2.7 6.41-2.72 2.87.02 5.07.94 6.52 2.73a8.88 8.88 0 0 1 1.61 3.27l2.02-.54a10.92 10.92 0 0 0-2.03-4.08C18.75 1.2 16.02.02 12.51 0h-.02C9 .02 6.3 1.2 4.47 3.51 2.86 5.56 2.03 8.41 2 11.99V12c.03 3.59.86 6.44 2.47 8.49C6.3 22.79 9 23.98 12.5 24h.02c3.12-.02 5.32-.84 7.13-2.65a6.5 6.5 0 0 0 1.52-7.16 6.13 6.13 0 0 0-3.1-3.07Zm-5.39 5.07c-1.3.07-2.66-.51-2.73-1.77-.05-.93.66-1.97 2.81-2.09l.72-.02c.78 0 1.51.07 2.18.22-.25 3.09-1.7 3.59-2.98 3.66Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadslarge);
export default __webpack_public_path__ + "static/media/threads.large.4daed81070a82b511d868a5ca4ca0304.svg";
export { ForwardRef as ReactComponent };